import { createFileRoute } from '@tanstack/react-router';
import LostPasswordPage from '@features/auth/lost-password.tsx';

export const Route = createFileRoute('/lost-password')({
  component: LostPasswordPage,
});
